import React from "react";
import DatePicker from './DatePicker'
import TextInput from './TextInput'
import FixButton from './Button'
import moment from 'moment';
import Cookies from 'universal-cookie';
import getInsegnanti from '../services/getInsegnanti';
import getMaterie from '../services/getMaterie';
import SelectInput from './SelectInput';
import translateString from "../utils/Locales";
import Utils from "../utils/utils";

let t = translateString;

export default class InsertEsame extends React.Component {

    constructor (props){
        super(props);

        this.dateRef = React.createRef();
        this.selectRef = React.createRef();

        this.state = {
            insegnante: props.insegnante ? { value: props.insegnante.id, label: props.insegnante.label.replace(/\\/g, '')} : undefined,
            isLoading: true, 
            materia: undefined,
            type: undefined,
        }

    }

    async componentDidMount() {

        const cookies = new Cookies();
        const username = cookies.get('username', { path: '/' });
        const token = cookies.get('token', { path: '/' });

        this.insegnanti = await getInsegnanti(username, token);
        this.materie = await getMaterie(username, token);

        this.selectInsegnanti = [];
        this.selectMaterie = [];
        this.selectType = [
            { value: 1, label: t('prova_scritta') },
            { value: 2, label: t('prova_orale') }
        ];

        this.insegnanti.forEach((insegnante) => {
            this.selectInsegnanti.push({ value: insegnante.id, label: insegnante.cognome.replace(/\\/g, '') + ' ' + insegnante.nome.replace(/\\/g, '') });
        });

        if (this.state.insegnante !== undefined) {
            this.materie.forEach((materia) => {
                if (materia.id_insegnante === this.props.insegnante.value) {
                    this.selectMaterie.push({ value: materia.id, label: materia.materia.replace(/\\/g, '') });
                }
            })
        }    
        this.setState({
            visible: this.props.show,
            titoloEsame: '', 
            isLoading: false,
            insegnante: this.props.insegnante,
        });

    }

    render (){

        if (!this.state) return <div />;
        let st = Object.assign({display: this.state.visible ? 'block' : 'none'});

        return ( 
        <div style={st} >
            <div style={container} onClick={() => { this.setState({visible: false}); this.props.onCancel(); }}>
                <div style={mainClass} onClick={(e) => e.stopPropagation()}>
                    <div style={closeIcon} onClick={() => {
                    this.setState({visible: false});
                    this.props.onCancel();
                    }}>
                        <img alt="" src={ require('../images/close_icon.png')} style={{ width: 30, height: 30, cursor: 'pointer' }} />
                    </div>
                    <div style={{marginTop: '10px'}}>
                        <div style={windowTitle}>{t('nuovo_esame')}</div>
                        <div style={{ display: 'flex', marginLeft: 5, marginBottom: 0, marginTop: 0 }}>
                            <img alt="" src={ require('../images/question_icon.png') } style={{ width: 10, height: 10, marginRight: 5, marginTop: 1 }} />
                            <p style={{ fontSize: 10, color: 'darkgray', maxWidth: '80%' }}>{t('nuovo_esame_info')}</p><br/>
                        </div>
                        
                        { !this.props.insegnanteSet && <SelectInput key={Math.random()} 
                            ref={this.selectRef}
                            value={this.state.insegnante} 
                            name={t('insegnante')} 
                            options={this.selectInsegnanti} 
                            onChange={(option) => {
                                this.selectMaterie = [];
                                this.setState({ materia: undefined });
                                this.materie.forEach((materia) => {
                                    if (materia.id_insegnante === option.value) {
                                        this.selectMaterie.push({ value: materia.id, label: materia.materia });
                                    }
                                });
                                this.setState({ insegnante: { value: option.value, label: option.label } });
                            } 
                        } /> }

                        <SelectInput key={Math.random()} 
                            ref={this.selectRef}
                            value={this.state.materia} 
                            name={t('materia')} 
                            options={this.selectMaterie} 
                            onChange={(option) => {
                                this.setState({ materia: { value: option.value, label: option.label } });
                            } 
                        } />

                        <SelectInput key={Math.random()} 
                            ref={this.selectRef}
                            value={this.state.type} 
                            name={t('tipologia') + " (*)"} 
                            options={this.selectType} 
                            onChange={(option) => {
                                this.setState({ type: { value: option.value, label: option.label } });
                            } 
                        } />
                        <br/>
                        <DatePicker ref={this.dateRef} value={new Date()} name="" placeholder={t('data') + " *"} inputStyle={{ borderLeft: 0, borderTop: 0, borderRight: 0, borderBottom: '1px solid darkgrey', width: '290px' }} />
                        <TextInput style={{ borderLeft: 0, borderTop: 0, borderRight: 0, borderBottom: '1px solid darkgrey', width: '290px' }} placeholder={t('note_esame')} name={''} value={this.state.titoloEsame} 
                            onChange={(text) => { this.setState({titoloEsame: text})} }/><br/>
                        <br/>
                        <FixButton title={t('salva')} callback={this.okClicked.bind(this)} />
                    </div>
                </div>
            </div>
        </div>
        )
    }

    async okClicked(){

        if (this.state.type === undefined) {
            Utils.showError(t('errore_prova'));
            return;
        }

        const daDate = this.dateRef.current.getDate();
        let dataEsame = moment(daDate).format('yyyy-MM-DD');
        if (dataEsame == "Invalid date") {
            Utils.showError(t('errore_data_prova'));
            return;
        };

        this.props.onOkClicked(this.state.insegnante.value, this.state.insegnante.label, this.state.materia.value, dataEsame, this.state.titoloEsame, this.state.type.value);
    }
}

const windowTitle = {
    color: 'darkgrey', 
    fontSize: 30, 
    fontWeight: 'bold', 
    fontFamily: 'Teko', 
    textAlign:'left', 
    marginLeft: 5, 
}


const closeIcon = {
    position: 'absolute', 
    cursor: 'pointer',
    right: 10, 
    top: 10, 
    padding: 10,
    zIndex: 999,
}

const container = {
    position: 'fixed', 
    display: 'block', 
    top: 0,
    left: 0, 
    bottom: 0, 
    right: 0,
    minWidth: '100%', 
    minHeight: '100%', 
    backgroundColor: '#3C3C3C4D',
    overflow: 'scroll',
    zIndex: 9999,
};

const mainClass = {
    position: 'absolute',
    left: 'calc((100% - 350px)/2',
    top: '110px',
    right: '35%',
    minWidth: '350px',
    width: '350px',
    background: 'white',
    padding: '20px',
    zIndex: 999,
    boxShadow: '0px 2px 10px darkgrey', 
    borderRadius: '10px',
}